import * as React from "react";
import "./styles.scss";
import { Display } from "../../../../../components/Display";

interface DeviceModelListItemProps {
	onItemToggle: (guid: string) => void;
	name: string;
	logo: string;
	guid: string;
	selected?: boolean;
}

export const DeviceModelListItem: React.FC<DeviceModelListItemProps> = ({
	onItemToggle,
	name,
	logo,
	guid,
	selected,
}) => {
	const [isSelected, setIsSelected] = React.useState(false ?? selected);
	const [imageLoaded, setImageLoaded] = React.useState(false);
	const handleImageLoaded = () => {
		setImageLoaded(true);
	};

	const handleItemSelect = () => {
		setIsSelected(!isSelected);
		onItemToggle(guid);
	};

	React.useEffect(() => setIsSelected(selected), [selected]);

	return (
		<div
			onClick={handleItemSelect}
			className={`device-model-list-item ${isSelected ? "selected" : ""}`}
		>
			<Display isVisible={!imageLoaded}>
				<div className={"device-model-image-loader skeleton"} />
			</Display>
			<img
				src={`${logo}`}
				alt={"Device model image"}
				width={70}
				height={70}
				onLoad={handleImageLoaded}
				className={"device-model-image clickable"}
				style={imageLoaded ? {} : { display: "none" }}
			/>
			<p className={"device-model-name"}>{name}</p>
		</div>
	);
};
